import { z } from 'zod'

// Optional sub-fields use .nullish() (not .optional()): ContentStack returns an
// explicit `null` for an empty optional field, which .optional() would reject.
export const RawCmsCtaSchema = z
  .object({
    text: z.string(),
    variant: z.enum(['primary', 'secondary']).nullish(),
    url: z.string().nullish(),
    trigger_promocode: z.boolean().nullish(),
  })
  .passthrough()
